import { type StatsItem } from "../models";

export const summarizeMetricsArray = (array: readonly StatsItem[]): number =>
    array.reduce((accumulator, { value }) => accumulator + value, 0);
